module.exports = __webpack_public_path__ + "static/media/1_en.c6af17f7.png";